// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"684":"f505cc3c","693":"a37a9b75"}[chunkId] + ".chunk.css";
};